export default {
    components: {
        TheLocaleSwitcher: {
            locales: {
                de: 'deutsch',
                en: 'english',
            },
            toast: 'Sprache geändert',
        },
        TheHeader: {
            viewNotifications: 'Benachrichtigungen anzeigen',
            goToInbox: 'Zum Postfach',
            noNews: 'Keine neuen Benachrichtigungen',
        },
    },
    pages: {
        DashboardPage: {
            title: 'Dashboard',
            statusTeaser: {
                title: 'Statuspage',
                content: 'Informationen zu zukünftigen und laufenden Wartungen.',
                action: 'Seite öffnen',
            },
            helpTeaser: {
                title: 'Knowledge Base',
                content: 'Weiterführende Informationen und antworten auf häufig gestellte Fragen.',
                action: 'Seite öffnen',
            },
            smokePingTeaser: {
                title: 'SmokePing',
                content: 'Prüfen Sie die Latenz unseres Netzwerks und messen Sie seine Leistung.',
                action: 'Seite öffnen',
            },
            contactTeaser: {
                title: 'Kontakte',
                phone: 'Telefon',
                mail: 'Mail',
                emergency: 'Notfall',
            },
            serviceTeaser: {
                title: 'Servicezeiten',
                mondayToThursday: 'Mo-Do:',
                mondayToThursdayOpeningHours: '08:00 – 17:00 Uhr',
                friday: 'Fr:',
                fridayOpeningHours: '08:00 – 15:30 Uhr',
                info: 'Alle Zeiten in deutscher Lokalzeit ({timeZone} [{utcDifference}])',
            },
            newsPostsSection: {
                title: 'Letzte @:pages.NewsPostIndexPage.title',
            },
            ticketSection: {
                title: 'Offene Tickets',
            },
            helpfulLinksSection: {
                title: 'Hilfreiche Links',
            },
        },
        CustomerPage: {
            title: 'Kundendaten',
            breadcrumb: '@:pages.CustomerPage.title',
            contactSection: {
                inactiveSwitch: 'Deaktivierte @:resources.contact.name',
            },
        },
        ContactPage: {
            breadcrumb: '@:resources.contact.name',
            rolesSection: {
                title: '@:resources.contact.attributes.roles',
                description: 'Jede Rolle hat eine oder mehrere Berechtigungen.',
                tooltip: {
                    grantedPermissions: 'Der Inhaber dieser Rolle hat folgende Berechtigungen:',
                    ownerCannotBeTransferred:
                        'Diese Rolle kann nur von einem 23M-Mitarbeiter übertragen werden.',
                    canOnlySetByOwner: 'Diese Rolle kann nur vom Inhaber gesetzt werden.',
                },
            },
            permissionsSection: {
                title: '@:resources.contact.attributes.permissions',
                description:
                    'Jede Berechtigung erlaubt den Zugriff auf bestimmte Funktionen oder Daten.',
                tooltip: {
                    grantedByRoles: 'Die folgenden aktiven Rollen gewähren diese Berechtigung:',
                    cannotBeRevoked:
                        'Diese Berechtigung kann entzogen werden, indem die entsprechenden Rollen entfernt werden.',
                },
            },
        },
        OrderIndexPage: {
            title: 'Aufträge',
            breadcrumb: '@:pages.OrderIndexPage.title',
            badge: {
                description:
                    'Es liegt {count} neues Angebot vor | Es liegen {count} neue Angebote vor',
            },
        },
        OrderPage: {
            title: 'Auftrag: {number}',
            breadcrumb: '{number}',
            offerSection: {
                title: 'Ihr persönliches Angebot',
                body: 'Mit einem Klick auf "Annehmen" bestätigen Sie das Angebot und schließen den Auftrag verbindlich ab. Wählen Sie "Ablehnen", können Sie uns einen Grund oder Ihre Änderungswünsche mitteilen, damit wir das Angebot entsprechend anpassen können.',
                actions: {
                    approve: 'Annehmen',
                    reject: 'Ablehnen',
                },
                approveDialog: {
                    title: 'Angebot annehmen?',
                    body: 'Mit der Annahme dieses Angebots lösen Sie eine verbindliche und kostenpflichtige Bestellung aus. Bitte überprüfen Sie vor Abschluss noch einmal alle Details.',
                    action: 'Kostenpflichtig annehmen',
                    successMessage: 'Angebot wurde angenommen.',
                },
                rejectDialog: {
                    title: 'Angebot ablehnen?',
                    body: 'Bitte teilen Sie uns mit, warum Sie das Angebot ablehnen oder welche Änderungen Sie wünschen. So können wir noch besser auf Ihre Anforderungen eingehen.',
                    fieldLabel: 'Grund für die Ablehnung',
                    fieldPlaceholder: 'Ich lehne das Angebot ab, weil ...',
                    action: 'Endgültig ablehnen',
                    successMessage: 'Angebot wurde abgelehnt.',
                },
            },
            type: {
                s3: {
                    managementInterfaceSection: {
                        title: 'Verwaltungsoberfläche',
                        groupName: 'Gruppenname: Customers',
                        incompleteSetUp:
                            'Der Zugang zur Verwaltungsoberfläche ist noch nicht vollständig eingerichtet. Bitte wenden Sie sich an unseren Support.',
                    },
                    endpointSection: {
                        title: 'S3-Endpunkte (via HTTP und HTTPS)',
                    },
                    pricingSection: {
                        title: 'Preise',
                        storage: {
                            title: 'Storage',
                            description: 'pro GB / pro Monat',
                        },
                    },
                },
                cloud: {
                    managementInterfaceSection: {
                        title: 'Verwaltungsoberfläche',
                    },
                    pricingSection: {
                        title: 'Preis',
                        titleWithDiscount: 'Preise inkl. {consumptionDiscountPercent}% Rabatt',
                        highAvailability: {
                            title: 'High availability storage',
                            attributes: {
                                name: 'Name',
                                vCPU: 'vCPU (Cores)',
                                RAM: 'RAM (GB)',
                                storage: 'Storage (GB)',
                                iops: 'Max. IOPS',
                                price: 'Preis pro Stunde',
                            },
                        },
                        highIops: {
                            title: 'High IOPS',
                            attributes: {
                                name: '@:pages.OrderPage.type.cloud.pricingSection.highAvailability.attributes.name',
                                vCPU: '@:pages.OrderPage.type.cloud.pricingSection.highAvailability.attributes.vCPU',
                                RAM: '@:pages.OrderPage.type.cloud.pricingSection.highAvailability.attributes.RAM',
                                storage:
                                    '@:pages.OrderPage.type.cloud.pricingSection.highAvailability.attributes.storage',
                                iops: '@:pages.OrderPage.type.cloud.pricingSection.highAvailability.attributes.iops',
                                price: '@:pages.OrderPage.type.cloud.pricingSection.highAvailability.attributes.price',
                            },
                        },
                        blockStorage: {
                            title: 'Block storage',
                            description:
                                'Zusätzlich buchbarer Netzwerkspeicher für Ihre Compute-Instanzen. Ideal zur Erweiterung der Kapazität, ohne bestehende Systeme zu verändern.',
                            keyFact1: 'Netzwerkgebundener NVMe-Speicher mit bis zu 2000 IOPS',
                            keyFact2: 'Bis zu 10 TB pro Volume',
                            keyFact3: 'Preis: {price} pro GB pro Stunde',
                        },
                    },
                },
                backup: {
                    managementInterfaceSection: {
                        managementInterface: 'Verwaltungsoberfläche',
                        incompleteSetUp:
                            'Der Zugang zur Verwaltungsoberfläche ist noch nicht vollständig eingerichtet. Bitte wenden Sie sich an unseren Support.',
                    },
                    endpointSection: {
                        title: 'Backup-Endpunkt (via HTTP oder HTTPS)',
                    },
                    pricingSection: {
                        title: 'Preise',
                        titleWithDiscount: 'Preise inkl. {consumptionDiscountPercent}% Rabatt',
                        storage: {
                            title: 'Storage',
                            description: 'pro TB / pro Monat',
                        },
                        device: {
                            title: 'Device',
                            description: 'pro Device / pro Monat',
                        },
                        booster: {
                            title: 'Booster',
                            hint: 'MongoDB oder Microsoft SQL',
                            description: 'pro Monat',
                        },
                    },
                    hint: 'Ihr Backup-Service bietet automatisierten Datenschutz mit flexiblen Zeitplänen und Aufbewahrungsrichtlinien. Nutzen Sie die Verwaltungsoberfläche, um den Backup-Status zu überwachen und Einstellungen zu konfigurieren.',
                },
            },
        },
        IpUsageIndexPage: {
            title: 'IPAM',
            breadcrumb: '@:pages.IpUsageIndexPage.title',
        },
        IpUsageNetworkPage: {
            title: 'IP-Netz',
            breadcrumb: 'IP-Netz',
        },
        OrderWanPage: {
            title: 'WAN-Traffic',
            breadcrumb: '@:pages.OrderWanPage.title',
        },
        OrderLanPage: {
            title: 'LAN-Traffic',
            breadcrumb: '@:pages.OrderLanPage.title',
        },
        OrderPowerPage: {
            title: 'Stromverbrauch',
            breadcrumb: '@:pages.OrderPowerPage.title',
        },
        DeviceUsageIndexPage: {
            title: 'Server',
            breadcrumb: '@:pages.DeviceUsageIndexPage.title',
        },
        DeviceUsagePage: {
            title: 'Server: {name}',
            breadcrumb: '{id}',
            temperaturesSection: {
                title: 'Temperaturen',
            },
            hardwareSection: {
                title: 'Hardware',
            },
        },
        RentUsageIndexPage: {
            title: 'Mietgeräte',
            breadcrumb: '@:pages.RentUsageIndexPage.title',
        },
        ColocationUsageIndexPage: {
            title: 'Colocation',
            subItem: 'Übersicht',
            breadcrumb: '@:pages.ColocationUsageIndexPage.title',
        },
        InvoiceIndexPage: {
            title: 'Rechnungen',
            breadcrumb: '@:pages.InvoiceIndexPage.title',
            badge: {
                description:
                    'Es liegt {count} offene Rechnung vor | Es liegen {count} offene Rechnungen vor',
            },
        },
        InvoicePaymentPage: {
            title: 'Rechnung bezahlen',
            breadcrumb: '{number}',
            paymentMethod: {
                title: 'Zahlungsmethode',
            },
            summary: {
                title: 'Rechnungsdetails',
            },
            security: {
                title: 'Sichere Zahlung',
                enum: {
                    ssl: '256-Bit-SSL-Verschlüsselung',
                    compliant: 'PCI DSS-konform',
                    stripe: 'Powered by Stripe',
                },
            },
            help: {
                title: 'Benötigen Sie Hilfe?',
                description:
                    'Wenn Sie Fragen zu Ihrer Zahlung haben, wenden Sie sich gerne an unseren Support.',
            },
        },
        InvoicePaymentSuccessPage: {
            title: 'Rechnung bezahlt',
            breadcrumb: '{number}',
            paymentForm: {
                initializing: 'Zahlungsformular wird initialisiert...',
                pleaseWait:
                    'Bitte warten Sie, während wir Ihr sicheres Zahlungsformular einrichten.',
                processingPayment: 'Zahlung läuft...',
                paymentFailed: 'Zahlung fehlgeschlagen',
                stripeInitializationFailed: 'Fehler beim Initialisieren des Zahlungsformulars',
            },
            thankYouSection: {
                title: 'Zahlung erfolgreich!',
                description:
                    'Ihre Zahlung wurde erfolgreich verarbeitet. Sie erhalten in Kürze eine Bestätigungs-Mail.',
                note: 'Vielen Dank für Ihr Vertrauen!',
                viewInvoices: 'Rechnungen anzeigen',
            },
        },
        TicketIndexPage: {
            title: 'Tickets',
            breadcrumb: '@:pages.TicketIndexPage.title',
        },
        TicketPage: {
            breadcrumb: '{id}',
            ticketCreated: 'hat @:resources.ticket.name angelegt',
            deletedUser: 'Gelöschter Benutzer',
            commented: 'hat kommentiert',
            avatarAlt: 'Profilbild von {name}',
            ticketSolved: 'Ticket wurde gelöst.',
            ticketSolvedAlert:
                'Dieses Ticket wurde bereits gelöst und kann nicht mehr bearbeitet werden.',
        },
        SettingsAccountPage: {
            title: 'Einstellungen',
            breadcrumb: '@:pages.SettingsAccountPage.title',
            navigation: {
                account: 'Login',
                notifications: 'Benachrichtigungen',
                api: 'API',
            },
            twoFactorAuthenticationDialog: {
                title: 'Zwei-Faktor-Authentifizierung aktivieren',
                step1Label: 'QR-Code scannen',
                step1Description:
                    'Verwenden Sie zum Scannen eine Authentifizierungs-App wie <a target="_blank" class="text-blue-700 hover:text-blue-600 hover:underline cursor-pointer" href="https://authy.com/"> Authy </a>, <a target="_blank" class="text-blue-700 hover:text-blue-600 hover:underline cursor-pointer" href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2&hl=de&gl=US"> Google Authenticator </a> oder eine Browser-Erweiterung wie die von <a target="_blank" class="text-blue-700 hover:text-blue-600 hover:underline cursor-pointer" href="https://1password.com/downloads/browser-extension/">1Password</a>.',
                confirmationCodeField: 'Bestätigungscode',
                step2Label: 'Bestätigungscode eingeben',
                step2Description:
                    'Geben Sie den Code aus der Authentifizierungs-App zur Bestätigung ein.',
                step3Label: 'Recovery Codes speichern',
                step3Description:
                    'Speichern Sie Ihre Recovery-Codes an einem sicheren Ort, damit Sie bei Verlust Ihrer Authentifizierungs-App wieder Zugriff auf Ihren Account bekommen können.',
            },
        },
        NewsPostIndexPage: {
            title: 'News',
            breadcrumb: '@:pages.NewsPostIndexPage.title',
        },
        DatacenterVisitIndexPage: {
            title: 'Datacenter Zugänge',
            subItem: 'Zugänge',
            breadcrumb: 'Datacenter Zugang',
            drawer: {
                title: 'Besuchsdetails',
            },
            actions: {
                createNewVisit: 'Anmeldung zum Datacenter',
            },
        },
        DatacenterVisitWizardPage: {
            title: 'Datacenter Besuch',
            headline: 'Besuch im Datacenter anmelden',
            ticket: {
                subjectPrefix: 'Anfrage Datacenter Access',
                subjectPrefixNoc: 'Anfrage Datacenter Access (Notfall Support) ',
                creationError: 'Fehler bei der Ticket-Erstellung. Bitte versuchen Sie es erneut.',
                creating: 'Ticket wird erstellt...',
            },
        },
        InboxPage: {
            title: 'Postfach',
            breadcrumb: 'Postfach',
            selectAll: 'Alle auswählen',
            selectAllPages: 'Alle Seiten auswählen',
            filters: {
                all: 'Alle',
                unread: 'Ungelesen',
                protect: '@:pages.AttackIndexPage.title',
                byType: 'Nach Typ',
                attachments: 'Anhänge',
            },
            bulkActions: {
                selected: '{count} ausgewählt',
                markRead: 'Als gelesen markieren',
                markUnread: 'Als ungelesen markieren',
                confirmDelete:
                    'Möchten Sie die Benachrichtigung wirklich löschen? | Möchten Sie wirklich {count} Benachrichtigungen löschen?',
                success: {
                    delete: 'Benachrichtigungen gelöscht',
                },
            },
            actions: {
                markRead: 'Als gelesen markieren',
                markUnread: 'Als ungelesen markieren',
                unsubscribe: 'Abbestellen',
            },
            emptyState: {
                title: 'Keine Benachrichtigungen',
                description: 'Sie haben derzeit keine Benachrichtigungen.',
            },
            confirmDelete: 'Möchten Sie diese Benachrichtigung wirklich löschen?',
            success: {
                deleted: 'Benachrichtigung gelöscht',
            },
        },
        AttackIndexPage: {
            title: 'Protect',
            breadcrumb: '@:pages.AttackIndexPage.title',
            trafficSection: {
                title: 'Überwachter Gesamt-Traffic',
            },
            attacksSection: {
                title: 'DDoS-Angriffe',
            },
        },
        AttackPage: {
            title: 'DDoS-Angriff',
            breadcrumb: 'DDoS-Angriff',
            trafficSection: {
                title: 'Überwachter IP-Traffic',
            },
            attackDetailsSection: {
                title: 'Angriffsdetails',
                sourceIp: 'Quell-IPs',
                sourceCountry: 'Quell-Länder',
                sourceAsn: 'Quell-ASNs',
                sourcePort: 'Quell-Ports',
                destinationPort: 'Ziel-Ports',
                packetLength: 'Paketlängen',
                protocol: 'Protokolle',
            },
        },
    },
    wizards: {
        datacenterVisit: {
            steps: {
                dateTime: {
                    progressbar: 'Datum & Uhrzeit',
                    title: 'Besuchszeitraum',
                    startDateLabel: 'Startdatum und -zeit',
                    endDateLabel: 'Enddatum und -zeit',
                    alerts: {
                        sla: 'Bitte beachten Sie, dass unser Datacenter-Team mindestens vier Stunden (innerhalb der Geschäftszeiten) benötigt, um Ihre Anfrage zu bearbeiten und die Anmeldung durchzuführen.',
                        noc: {
                            requiredDescription:
                                'Es wird automatisch ein Notfall Support-Ticket eröffnet, da folgende Gründe vorliegen:',
                            reasons: {
                                holiday: 'Die Anfrage fällt auf einen Feiertag',
                                weekend: 'Die Anfrage fällt auf ein Wochenende',
                                outsideBusinessHours:
                                    'Die Anfrage liegt außerhalb unserer Geschäftszeiten',
                            },
                        },
                        businessHoursTitle: 'Unsere Geschäftszeiten:',
                    },
                },
                visitors: {
                    title: 'Wer soll angemeldet werden?',
                    contacts: {
                        progressbar: 'Interne Besucher',
                        selectUsersLabel: 'Mitarbeitende des Unternehmens',
                        selectUserPlaceholder: 'Fügen Sie Besucher hinzu',
                        loadingContacts: 'Lade Kontakte...',
                        noContactsAvailable: 'Keine Kontakte verfügbar',
                        userNameLabel: 'Ich',

                        passportNamePlaceholder: 'Name laut Ausweis',
                        visitorCount: 'Gesamtzahl der Besucher: {count} von maximal {max}',
                        alerts: {
                            passportName: {
                                match: 'Die angegebenen Namen müssen exakt mit den Daten auf Ihrem Ausweisdokument übereinstimmen.',
                                deviations:
                                    'Sollte es Abweichungen geben, nutzen Sie bitte die Freifelder und tragen Sie dort Ihren vollständigen Namen gemäß Ausweis ein',
                            },
                        },
                    },
                    guests: {
                        progressbar: 'Externe Besucher',
                        label: 'Gäste des Unternehmens',
                        guestNamePlaceholder: 'Name laut Ausweis',
                        passportDialog: {
                            title: 'Bestätigung der Ausweisdaten',
                            message:
                                'Bitte bestätigen Sie, dass alle angegebenen Namen mit den jeweiligen Ausweisdokument vollständig übereinstimmen. Dies ist für den Zugang zum Datacenter erforderlich.',
                            confirm: 'Bestätigen',
                            doNotShowAgain: 'Diese Meldung nicht mehr anzeigen',
                        },
                    },
                    actions: {
                        addGuest: 'Besucher hinzufügen',
                        addSelfAsVisitor: 'Mich als Besucher hinzufügen',
                    },
                    validation: {
                        noVisitorsSelected: 'Bitte melden Sie mindestens einen Besucher an',
                        userNameValidationError:
                            'Der Name muss Teile des ursprünglichen Namens enthalten',
                    },
                },
                rackAccess: {
                    progressbar: 'Rack-Zugang',
                    title: 'Rack-Zugang',
                    rackAccessLabel: 'Zu welchen Racks soll der Zugang eingerichtet werden?',
                    unlockRackLabel: 'Rack wird vom Datacenter-Team aufgeschlossen',
                    validation: {
                        selectAtLeastOneRack: 'Bitte wählen Sie mindestens ein Rack aus.',
                    },
                    alerts: {
                        extraCostDetails: {
                            title: 'Zusätzliche Kosten möglich',
                            warning:
                                'Einige Racks können zusätzliche Kosten verursachen, wenn sie durch unser Datacenter-Team geöffnet werden müssen.',
                            checkSelf:
                                'Bitte prüfen Sie vorab, ob Sie im Besitz eines eigenen Rack-Schlüssels sind.',
                        },
                    },
                },
                message: {
                    progressbar: 'Ihre Nachricht',
                    title: 'Ihre Nachricht an uns',
                    additionalInfoLabel: 'Ihre Nachricht an uns',
                },
                summary: {
                    progressbar: 'Zusammenfassung',
                    title: 'Überprüfen Sie Ihre Angaben',
                    detailsTitle: 'Details',
                    visitDate: 'Besuch',
                    visitFrom: 'Von',
                    visitTo: 'bis',
                    visitors: 'Besucher',
                    selectedRacks: 'Zugang zu Racks',
                    needsUnlocking: ' (Rack wird vom Datacenter-Team aufgeschlossen)',
                    nocTicket: 'Notfall Support',
                    termsLabel:
                        'Ich habe zur Kenntnis genommen, dass meine Anmeldung zunächst geprüft wird und der Datacenter-Besuch erst nach einer gesonderten Bestätigung durch 23M als verbindlich gilt.',
                    actions: {
                        submitVisit: 'Besuch anmelden',
                    },
                },
                thanksCard: {
                    title: 'Vielen Dank für Ihre Anfrage',
                    message:
                        'Ihre Anfrage wurde erfolgreich übermittelt und wird so schnell wie möglich bearbeitet. Eine separate Anmeldebestätigung für Ihren Besuch erhalten Sie in Kürze. <br /> ' +
                        '<br /> Sie können sich nun entspannt zurücklehnen oder direkt zu unseren Services zurückkehren.',
                    teamPrefix: 'Ihr',
                    teamSuffix: '-Team',
                },
            },
        },
    },
    resources: {
        address: {
            name: 'Adresse | Adressen',
            attributes: {
                street: 'Straße',
                number: 'Hausnummer',
                zip: 'PLZ',
                city: 'Stadt',
                additional: 'Zusatz',
                country: 'Land',
            },
            emptyState: {
                title: '@:resources.address.name anlegen',
            },
            emptyStateNoPermission: {
                title: 'Keine @:resources.address.name gefunden',
            },
        },
        country: {
            name: 'Land | Länder',
            attributes: {
                code: 'Ländercode',
                name: 'Name',
            },
        },
        bankAccount: {
            name: 'Bankverbindung | Bankverbindungen',
            emptyState: {
                title: '@:resources.bankAccount.name anlegen',
                body: 'Wenden Sie sich an unseren Support und legen Sie ihre @:resources.bankAccount.name an',
                mailSubject: '[23M.com] Bankverbindung anlegen ({customerNumber})',
                mailBody:
                    'Hallo 23M-Support-Team,%0D%0A%0D%0A ich möchte gerne folgende Bankverbindung anlegen...',
            },
        },
        contact: {
            name: 'Kontaktperson | Kontaktpersonen',
            attributes: {
                name: 'Name',
                contactData: 'Kontaktdaten',
                email: 'Mail',
                phone: 'Telefon',
                mobile: 'Mobil',
                roles: 'Rollen',
                permissions: 'Berechtigungen',
            },
            enums: {
                roles: {
                    owner: 'Inhaber',
                    admin: 'Admin',
                    technician: 'Techniker',
                    accountant: 'Buchhalter',
                },
                permissions: {
                    can_manage_contacts: {
                        name: 'Kontakte verwalten',
                        description:
                            'Kann Kontakte anlegen, bearbeiten, deaktivieren, aktivieren und Logins erstellen.',
                    },
                    can_manage_customer: {
                        name: 'Kundendaten verwalten',
                        description: 'Kann Rechnungs-Mail und Adresse bearbeiten',
                    },
                    can_access_receipts: {
                        name: 'Zugriff auf Rechnungen',
                    },
                    can_access_services: {
                        name: 'Zugriff auf Services',
                    },
                    can_book_datacenter_visit_for_self: {
                        name: 'Sich selbst zum Besuch im Datacenter anmelden',
                        description: '',
                    },
                    can_book_datacenter_visit_for_others: {
                        name: 'Kollegen und Gäste zum Besuch im Datacenter anmelden',
                        description: '',
                    },
                    can_see_all_datacenter_visits: {
                        name: 'Kann angemeldeten Besuche aller Mitarbeiter im Datacenter sehen',
                        description: '',
                    },
                },
            },
            actions: {
                add: '@:resources.contact.name anlegen',
                addRole: {
                    error: 'Rolle konnte nicht hinzugefügt werden.',
                },
                removeRole: {
                    error: 'Rolle konnte nicht entfernt werden.',
                },
                addPermission: {
                    error: 'Berechtigung konnte nicht hinzugefügt werden.',
                },
                removePermission: {
                    error: 'Berechtigung konnte nicht entfernt werden.',
                },
            },
            emptyState: {
                title: '@:resources.contact.name anlegen',
            },
            messages: {
                canNotDeleteYourself: 'Sie können sich selbst nicht löschen.',
                deactivateConfirmation:
                    'Möchten Sie diese @:resources.contact.name wirklich deaktivieren?',
            },
        },
        role: {
            name: 'Rolle | Rollen',
        },
        permission: {
            name: 'Berechtigung | Berechtigungen',
        },
        customer: {
            name: 'Kunde',
            attributes: {
                number: 'Kunde',
                name: 'Name',
                vat_id: 'USt.-ID',
                payment_type: 'Zahlungsart',
                payment_due_days: 'Zahlungsziel',
                receipt_mail_address: 'Rechnungs-Mail',
            },
            enums: {
                payment_type: {
                    bank_transfer: 'Überweisung',
                    direct_debit: 'Bankeinzug',
                    paypal: 'Paypal',
                },
            },
            receiptMailAddressEmptyState: {
                title: '@:resources.customer.attributes.receipt_mail_address anlegen',
            },
            receiptMailAddressEmptyStateNoPermission: {
                title: 'Keine @:resources.customer.attributes.receipt_mail_address gefunden',
            },
        },
        user: {
            name: 'Benutzer',
            nameAlternative: 'Login',
            attributes: {
                name: 'Name',
                password: 'Passwort',
                recovery_codes: 'Recovery Codes',
            },
            actions: {
                createAccount: {
                    label: '@:resources.user.nameAlternative anlegen',
                    hint: 'Es wird ein Login anhand der Kontakdaten angelegt und eine Einladungs-Mail verschickt.',
                },
                confirmPassword: 'Passwort bestätigen',
                activateTwoFactorAuthentication: {
                    successMessage: 'Zwei-Faktor-Authentifizierung aktiviert',
                },
                deactivateTwoFactorAuthentication: {
                    successMessage: 'Zwei-Faktor-Authentifizierung deaktiviert',
                },
                addNotificationType: {
                    error: 'Benachrichtigungstyp konnte nicht hinzugefügt werden.',
                },
                removeNotificationType: {
                    error: 'Benachrichtigungstyp konnte nicht entfernt werden.',
                },
            },
            enums: {
                notificationTypes: {
                    miscellaneous: 'Sonstiges',
                    maintenance: 'Wartung',
                    price_list: 'Preisliste',
                    outage: 'Störung',
                    order_start: 'Auftragsstart',
                    cancelation: 'Kündigung',
                    order_approved_by_customer: 'Freigabe',
                    receipt: 'Rechnung',
                    invoice_paid: 'Zahlung',
                    attack_started: 'Angriff gestartet',
                    attack_ended: 'Angriff beendet',
                },
            },
        },
        inboxNotification: {
            name: 'Benachrichtigung',
            enums: {
                status: {
                    unread: 'Ungelesen',
                    read: 'Gelesen',
                },
                type: {
                    miscellaneous: 'Sonstiges',
                    maintenance: 'Wartung',
                    price_list: 'Preisliste',
                    outage: 'Störung',
                    order_start: 'Auftragsstart',
                    cancelation: 'Kündigung',
                    order_approved_by_customer: 'Freigabe',
                    attack_started: '@:pages.AttackIndexPage.title',
                    attack_ended: '@:pages.AttackIndexPage.title',
                },
            },
            notificationContent: {
                greetings: 'Mit freundlichen Grüßen',
                team: 'Ihr 23M-Team',
            },
            attributes: {
                checkbox: '',
                subject: 'Betreff',
                content: 'Inhalt',
                type: 'Typ',
                created_at: 'Empfangen am',
                read_at: 'Gelesen am',
                attachments: 'Anhänge',
            },
        },
        order: {
            name: 'Auftrag',
            attributes: {
                number: 'Auftrag',
                customer_reference: 'Referenz',
                status: 'Status',
                type: 'Auftragsart',
                completed_at: 'Komplett seit',
                approved_at: 'Bearbeitet seit',
                planned_start_at: 'Geplant zum',
                start_at: 'Startdatum',
                end_at: 'Gekündigt zum',
                setup_price: 'Einmalig',
                monthly_price: 'Monatlich',
                price: 'Preis',
                cancelation_period: 'Kündigungsfrist',
                extension_period: 'Verlängerung',
                min_order_duration: 'Mindestlaufzeit',
            },
            enums: {
                status: {
                    draft: 'Draft',
                    completed: 'Angebot',
                    approved_by_customer: 'Vom Kunden genehmigt',
                    approved: 'Genehmigt',
                    due: 'Fällig',
                    active: 'Aktiv',
                    canceled: 'Gekündigt',
                    terminated: 'Gekündigt',
                    rejected: 'Abgelehnt',
                },
                decoratedStatus: {
                    startAt: 'Startet am: {date}',
                    startsShortly: 'Startet in Kürze',
                    endAt: 'Gekündigt zum {date}',
                },
                type: {
                    dedicated: 'Dedicated Server',
                    rent: 'Miete',
                    colocation: 'Colocation',
                    service: 'Service',
                    cloudserver: 'Cloud Server',
                    cloud: 'Cloud',
                    ip: 'Ip',
                    s3: 'S3 Object Storage',
                    domain_robot: 'Domain',
                    network: 'Network',
                    backup: 'Backup',
                },
            },
            actions: {
                createCustomerReference: 'Referenz erstellen',
                editCustomerReference: 'Referenz bearbeiten',
            },
            ticket: {
                subject: '[@:resources.order.name {orderNumber}] ',
            },
        },
        orderItem: {
            name: 'Auftragsposition | Auftragspositionen',
            attributes: {
                category: 'Kategorie',
                type: 'Typ',
                description: 'Beschreibung',
            },
            enums: {
                category: {
                    device: 'Hardware',
                    ram: 'RAM',
                    storage: 'Storage',
                    gpu: 'GPU',
                    network: 'Netzwerk',
                    service: 'Service | Services',
                    ip: 'IP-Adresse | IP-Adressen',
                    s3: 'S3 Object Storage',
                    power: 'Strom',
                    unknown: 'Unknown',
                    vpn: 'VPN',
                    peripheral: 'Zubehör',
                },
            },
            actions: {
                ipmiRequest: 'IPMI anzeigen',
                showLanTrafficGraph: 'LAN-Traffic',
            },
            errors: {
                ipmiRequest:
                    'Bei der IPMI-Abfrage ist ein Fehler aufgetreten. Bitte versuchen Sie es später noch einmal.',
            },
        },
        ipUsageAddress: {
            name: '',
            attributes: {
                ip: 'IP-Adresse | IP-Adressen',
                order_number: '@:resources.order.name',
                dns_name: 'rDNS Name',
                customer_reference: 'Referenz',
            },
        },
        ipUsageNetwork: {
            name: '',
            attributes: {
                ip: 'IP-Netz | IP-Netze',
                order_number: '@:resources.order.name',
                network_ips: 'rDNS-Einträge',
                has_dns_management: '@:resources.ipUsageAddress.attributes.has_dns_management',
                customer_reference: '@:resources.ipUsageAddress.attributes.customer_reference',
            },
        },
        networkIp: {
            name: '',
            attributes: {
                ip: 'IP-Adresse | IP-Adressen',
                mask: 'Subnetzmaske',
                dns_name: 'rDNS Name',
            },
        },
        vpnIpUsage: {
            name: 'VPN',
            attributes: {
                ip: 'IP-Adresse | IP-Adressen',
                order_number: '@:resources.order.name',
            },
        },
        deviceUsage: {
            name: 'Server | Server',
            attributes: {
                device_unit_name: 'Server',
                device_unit_old_name: 'Legacy-Name',
                order_device_item_customer_reference: 'Referenz',
                device_name: 'Typ',
                cpu: 'CPU',
                order_number: 'Auftrag',
                customer_reference: '@:resources.ipUsageAddress.attributes.customer_reference',
                device_unit_component_unit_descriptions: 'Komponenten',
                device_unit_netbox_item_rack_name: 'Rack',
                device_unit_netbox_item_rack_room: 'Raum',
            },
            actions: {
                createCustomerReference:
                    '@:resources.deviceUsage.attributes.customer_reference anlegen',
                editCustomerReference:
                    '@:resources.deviceUsage.attributes.customer_reference bearbeiten',
            },
            ticket: {
                subject: '[@:resources.deviceUsage.name {name}] ',
            },
            messages: {
                hardwareManagementUnavailable: {
                    title: 'System-Informationen nicht verfügbar',
                    description:
                        'Für diesen Server konnten keine System-Informationen abgerufen werden. Bei Fragen wenden Sie sich gerne an <a href="#" class="underline cursor-pointer">unseren Support</a>.',
                },
                hardwareManagementUnauthorized: {
                    title: 'Keine Berechtigung für diesen Server',
                    description:
                        'Es fehlen Berechtigungen für diesen Server. Wenden Sie sich gerne an <a href="#" class="underline cursor-pointer">unseren Support</a>.',
                },
                hardwareManagementError: {
                    title: 'Fehler beim Abrufen der System-Informationen',
                    description:
                        'Es ist ein Fehler aufgetreten. Wenden Sie sich gerne an <a href="#" class="underline cursor-pointer">unseren Support</a>.',
                },
            },
        },
        deviceUsageHardwareManagement: {
            name: 'System | Systeme',
            attributes: {
                manufacturer: 'Hersteller',
                model: 'Modell',
                serial_number: 'Seriennummer',
                status_health: 'Gesundheitsstatus',
                power_state: 'Betriebszustand',
                bios_version: 'BIOS-Version',
                indicator_led: 'Status-LED',
                status_state: 'Status',
                memory_health: 'Arbeitsspeicher-Gesundheit',
                processor_health: 'Prozessor-Gesundheit',
                name: 'Name',
            },
            enums: {
                health_state: {
                    ok: 'OK',
                    warning: 'Warnung',
                    critical: 'Kritisch',
                    unknown: 'Unbekannt',
                },
                power_state: {
                    on: 'An',
                    off: 'Aus',
                    powering_on: 'Wird eingeschaltet',
                    powering_off: 'Wird ausgeschaltet',
                    paused: 'Gestoppt',
                },
                state: {
                    enabled: 'Aktiviert',
                    disabled: 'Deaktiviert',
                    offline: 'Offline',
                    absent: 'Abwesend',
                    starting: 'Starten',
                    unavailable_offline: 'Offline nicht verfügbar',
                },
                indicator_led_state: {
                    lit: 'An',
                    off: 'Aus',
                    blinking: 'Blinkend',
                },
                physical_context: {
                    Room: 'Raum',
                    Intake: 'Ansaugung',
                    Exhaust: 'Abluft',
                    LiquidInlet: 'Flüssigkeitseinlass',
                    LiquidOutlet: 'Flüssigkeitsauslass',
                    Front: 'Vorderseite',
                    Back: 'Rückseite',
                    Upper: 'Oben',
                    Lower: 'Unten',
                    Left: 'Links',
                    Right: 'Rechts',
                    Chassis: 'Gehäuse',
                    Backplane: 'Rückwandplatine',
                    SystemBoard: 'Systemplatine',
                    PowerSupply: 'Netzteil',
                    VoltageRegulator: 'Spannungsregler',
                    Rectifier: 'Gleichrichter',
                    Transformer: 'Transformator',
                    ACInput: 'Wechselstromeingang',
                    ACOutput: 'Wechselstromausgang',
                    DCBus: 'Gleichstrombus',
                    PowerSubsystem: 'Stromversorgungssubsystem',
                    CPU: 'CPU',
                    CPUSubsystem: 'CPU-Subsystem',
                    Memory: 'RAM',
                    MemorySubsystem: 'RAM-Subsystem',
                    GPU: 'GPU',
                    GPUSubsystem: 'GPU-Subsystem',
                    ASIC: 'ASIC',
                    FPGA: 'FPGA',
                    Accelerator: 'Beschleuniger',
                    StorageDevice: 'Storage',
                    NetworkingDevice: 'Network',
                    Transceiver: 'Transceiver',
                    ComputeBay: 'Recheneinheit-Schacht',
                    StorageBay: 'Storage-Schacht',
                    NetworkBay: 'Netzwerk-Schacht',
                    ExpansionBay: 'Erweiterungs-Schacht',
                    Fan: 'Lüfter',
                    Blade: 'Blade',
                    Module: 'Modul',
                },
                power_state_action: {
                    On: 'Einschalten',
                    ForceOff: 'Force Off',
                    ForceOn: 'Force On',
                    ForceRestart: 'Force Reboot',
                    GracefulShutdown: 'Graceful Shutdown',
                    GracefulRestart: 'Graceful Reboot',
                    PushPowerButton: 'Power Button',
                    Nmi: 'NMI auslösen',
                    PowerCycle: 'Power Cycle',
                },
            },
        },
        rentUsage: {
            name: 'Rental | Rentals',
            attributes: {
                device_unit_name: 'Mietgerät',
                device_name: '@:resources.deviceUsage.attributes.device_name',
                order_number: '@:resources.deviceUsage.attributes.order_number',
                device_unit_serial: 'Serial',
                device_type: 'Gerätetyp',
            },
            ticket: {
                subject: '[@:resources.rentUsage.name {name}] ',
            },
        },
        colocationUsage: {
            name: '',
            attributes: {
                id: 'ID',
                rack_name: 'Rack',
                rack_room: 'Raum',
                order_number: '@:resources.order.name',
                order_colocation_item_customer_reference:
                    '@:resources.ipUsageAddress.attributes.customer_reference',
                order_colocation_item_colocation_name: 'Produkt',
                order_colocation_item_order_feed_item_current_power_consumption: 'Stromverbrauch',
            },
            actions: {
                createCustomerReference:
                    '@:resources.colocationUsage.attributes.order_colocation_item_customer_reference anlegen',
                editCustomerReference:
                    '@:resources.colocationUsage.attributes.order_colocation_item_customer_reference bearbeiten',
            },
            ticket: {
                subject: '[@:resources.order.name {name}] ',
            },
        },
        orderTrafficItem: {
            name: 'Traffic',
            attributes: {
                pricePerUnit: 'Je weitere {unit} {price}',
            },
            actions: {
                showWanTrafficGraph: 'WAN-Traffic',
            },
        },
        orderS3Item: {
            name: 'S3 Object Storage',
            attributes: {
                username: 'Benutzer-ID',
                pricing: '{pricePerUnit} pro GB / pro Monat',
            },
            actions: {
                managementInterface: 'Öffnen',
            },
        },
        orderCloudItem: {
            name: 'Cloud',
            attributes: {
                account_name: 'Username',
                password: 'Password',
                domain_name: 'Domain',
            },
            actions: {
                openManagementInterface: 'Open',
                requestPassword: {
                    label: 'Passwort anfordern',
                    confirm: 'Passwort einmalig anfordern',
                    hint: 'Da uns Ihre Sicherheit am Herzen liegt, können Sie Ihr Passwort nur einmal anfordern. Bitte bewahren Sie es sicher auf (z.B. in einem Passwortmanager). Bei Problemen steht Ihnen unser Support gerne zur Verfügung.',
                    success: 'Passwort erfolgreich angefordert',
                    disabled: 'Wurde bereits angefordert',
                },
            },
        },
        orderIpItem: {
            name: 'IP-Adressen',
        },
        orderDomainItem: {
            name: 'Domain Services',
            attributes: {
                domain_username: 'Benutzername',
            },
            actions: {
                openDomainRobot: 'Domain Robot öffnen',
            },
        },
        orderBackupItem: {
            name: 'Backup',
            attributes: {
                storage_pricing: 'Storage: {price} pro TB / pro Monat',
                device_pricing: 'Geräte: {price} pro Gerät / pro Monat',
                user_id: 'Benutzer-ID',
                password: 'Passwort',
            },
            actions: {
                open: 'Öffnen',
                requestPassword: {
                    label: 'Passwort anfordern',
                    confirm: 'Passwort einmalig anfordern',
                    hint: 'Da uns Ihre Sicherheit am Herzen liegt, können Sie Ihr Passwort nur einmal anfordern. Bitte bewahren Sie es sicher auf (z.B. in einem Passwortmanager). Bei Problemen steht Ihnen unser Support gerne zur Verfügung.',
                    success: 'Passwort erfolgreich angefordert',
                    disabled: 'Wurde bereits angefordert',
                },
            },
        },
        orderFeedItem: {
            attributes: {
                fuse_protection: 'Absicherung je Feed {fuseProtection} A',
            },
        },
        orderPowerItem: {
            pricing: '{pricePerUnit} pro kWh',
        },
        orderColocationItem: {
            attributes: {
                rack_name: 'Rack',
            },
        },
        orderCloudserverItem: {
            name: 'Cloud Server',
        },
        orderLockerItem: {
            name: 'Schließfach',
            attributes: {
                locker_room: 'Raum',
                locker_name: 'Schrank',
                compartment: 'Fach',
            },
        },
        orderVpnItem: {
            name: '{ count } { type } | { count } { type }s',
        },
        orderCrossConnectItem: {
            name: 'Cross Connect',
            attributes: {
                type: 'Typ',
                usage_interface_name: 'Name',
                netbox_cross_connect_name: 'Kennung',
                netbox_rack_name: 'Rack',
                netbox_rack_room: 'Raum',
                connected_item_order_number: 'Verbundener Auftrag',
            },
        },
        invoice: {
            name: 'Rechnung | Rechnungen',
            attributes: {
                number: 'Rechnung',
                status: 'Status',
                date: 'Rechnungsdatum',
                due_on: 'Fälligkeit',
                total_net: 'Netto',
                total_gross: 'Brutto',
            },
            enums: {
                status: {
                    open: 'Offen',
                    paid: 'Bezahlt',
                },
            },
        },
        ticket: {
            name: 'Ticket | Tickets',
            attributes: {
                subject: 'Betreff',
                id: 'ID',
                number: 'Ticket',
                created_at: 'Angelegt am',
                updated_at: 'Letzte Aktivität',
                status: 'Status',
                topic: 'Thema',
                description: 'Beschreibung',
            },
            enums: {
                status: {
                    open: 'Offen',
                    pending: 'Wartet auf Informationen',
                    solved: 'Gelöst',
                    closed: 'Geschlossen',
                },
                statusHint: {
                    open: 'Dieses Ticket befindet sich derzeit in Bearbeitung.',
                    pending: 'Für dieses Ticket werden noch weitere Informationen benötigt.',
                    solved: 'Das Ticket wurde gelöst. Weitere Kommentare sind noch 90 Tage lang möglich.',
                    closed: 'Dieses Ticket wurde geschlossen. Weitere Kommentare sind nicht mehr möglich. Bitte erstellen Sie stattdessen ein neues Ticket.',
                },
                topic: {
                    sales: 'Produkt- oder Angebotsanfrage',
                    finance: 'Frage zu einer Abrechnung',
                    technic: 'Technischer Support (während der Geschäftszeit)',
                    emergency: 'Technischer Notfall (außerhalb der Geschäftszeit)',
                    miscellaneous: 'Sonstiges',
                    datacenterAccess: 'Avisierung Datacenter (während der Geschäftszeit)',
                    datacenterAccessEmergency: 'Notfall Avisierung Datacenter (NOC)',
                },
            },
            actions: {
                selectStatus: 'Beliebig',
                create: '@:resources.ticket.name anlegen',
            },
        },
        ticketComment: {
            name: 'Kommentar | Kommentare',
        },
        attack: {
            name: 'DDoS-Angriff | DDoS-Angriffe',
            attributes: {
                attack_id: 'DDoS-Angriff',
                ip_address: 'IP-Adresse',
                status: 'Status',
                date: 'Datum',
                duration: 'Dauer',
                time: ' @:resources.attack.attributes.date / @:resources.attack.attributes.duration',
                peak: 'Peak',
                volume: 'Volumen',
                dimension:
                    ' @:resources.attack.attributes.peak / @:resources.attack.attributes.volume',
                description: 'Beschreibung',
            },
            enums: {
                status: {
                    start: 'Beginn',
                    ongoing: 'Laufend',
                    end: 'Ende',
                },
            },
            filters: {
                timeRange: {
                    label: 'Zeitraum',
                },
            },
        },
        attackTrafficDataPoint: {
            name: 'Traffic Datenpunkt | Traffic Datenpunkte',
            attributes: {
                date: 'Datum & Uhrzeit',
                allowedTraffic: 'Erlaubter Traffic',
                blockedTraffic: 'Blockierter Traffic',
            },
        },
        datacenterVisit: {
            attributes: {
                contact_id: 'Anmelder',
                created_at: 'Anmeldedatum',
                visit_start: 'Besuch Start',
                visit_end: 'Besuch Ende',
                visit: 'Besuch',
                visitors: 'Besucher',
                racks: 'Racks',
                notes: 'Ihre Nachricht an uns',
                is_noc: 'Notfall Support',
                ticket_number: 'Ticket',
                ticket_status: 'Status',
            },
        },
    },
    messages: {
        info: {
            newOffer: 'Sie haben ein neues Angebot',
            empty: 'Keine Daten gefunden.',
        },
        success: {
            saved: 'Erfolgreich gespeichert',
            deleted: 'Erfolgreich gelöscht',
        },
        confirm: {
            delete: 'Sind Sie sicher, dass Sie diese Referenz löschen möchten?',
        },
        thanks: {
            title: 'Danke für Ihr Vertrauen',
            description: 'Wir werden umgehend mit der Umsetzung beginnen.',
        },
        errors: {
            attachmentInvalidType:
                'Mindestens ein Anhang hat einen ungültigen Dateityp. Erlaubte Formate: PDF, JPG, PNG, GIF, WebP, TXT, CSV, DOC, DOCX, XLS, XLSX.',
            ticketNotCreated:
                'Es konnte kein @:resources.ticket.name angelegt werden. Bitte überprüfen Sie das Formular.',
            ticketCommentNotCreated:
                'Es konnte kein @:resources.ticketComment.name erstellt werden. Bitte überprüfen Sie das Formular.',
        },
    },
    forms: {
        optional: 'Optional',
        addressDach: {
            street: {
                label: 'Straße',
                placeholder: '',
            },
            number: {
                label: 'Hausnummer',
                placeholder: '',
            },
            country: {
                label: 'Land',
            },
            zip: {
                label: 'PLZ',
                placeholder: '',
            },
            city: {
                label: 'Stadt',
                placeholder: '',
            },
            additional: {
                label: 'Zusatz',
                placeholder: '',
            },
        },
        addressNonDach: {
            street: {
                label: 'Straße & Hausnummer',
                placeholder: '',
            },
            country: {
                label: 'Land',
            },
            city: {
                label: 'PLZ & Stadt',
                placeholder: '',
            },
            additional: {
                label: 'Zusatz',
                placeholder: '',
            },
        },
        contact: {
            title: {
                label: 'Titel',
                placeholder: '',
            },
            first_name: {
                label: 'Vorname',
                placeholder: '',
            },
            last_name: {
                label: 'Nachname',
                placeholder: '',
            },
            gender: {
                label: 'Anrede',
                options: {
                    male: 'Herr',
                    female: 'Frau',
                    diverse: 'Divers',
                    not_specified: 'Keine Angabe',
                },
            },
            email: {
                label: 'Mail',
                placeholder: '',
            },
            phone: {
                label: 'Telefon',
                placeholder: '',
            },
            mobile: {
                label: 'Mobile',
                placeholder: '',
            },
        },
        updateUserPassword: {
            title: 'Passwort ändern',
            description: 'Aktualisieren Sie Ihr Passwort, das mit Ihrem Konto verknüpft ist.',
            password_current: {
                label: 'Aktuelles Passwort',
                placeholder: '',
            },
            password: {
                label: 'Neues Passwort',
                placeholder: '',
            },
            password_confirmation: {
                label: 'Passwort wiederholen',
                placeholder: '',
            },
        },
        twoFactorAuthentication: {
            title: 'Zwei-Faktor-Authentifizierung',
            description:
                'Erhöhen Sie die Sicherheit Ihres Kontos mit einer Zwei-Faktor-Authentifizierung.',
            has_two_factor_authentication: {
                label: 'Authenticator App',
            },
            recovery_codes: {
                label: '@:resources.user.attributes.recovery_codes',
            },
        },
        notificationType: {
            title: 'Benachrichtigungen',
            description:
                'Passen Sie Ihre Benachrichtigungen individuell an – damit Sie immer genau das mitbekommen, was für Sie wichtig ist.',
            groupSummary: '{enabled} von {total} aktiv',
            columns: {
                type: 'Typ',
                mail: '@:forms.notificationType.channelPreferences.mail',
                inbox: '@:forms.notificationType.channelPreferences.inbox',
            },
            miscellaneous: {
                label: '@:resources.user.enums.notificationTypes.miscellaneous',
                hint: 'Allgemeine Hinweise und Informationen, die keiner bestimmten Kategorie zugeordnet sind.',
            },
            maintenance: {
                label: '@:resources.user.enums.notificationTypes.maintenance',
                hint: 'Geplante Wartungsarbeiten, die Ihre Services betreffen könnten - rechtzeitig und transparent.',
            },
            price_list: {
                label: '@:resources.user.enums.notificationTypes.price_list',
                hint: 'Aktualisierungen zu unseren Preisen, Tarifänderungen oder neue Angebote.',
            },
            outage: {
                label: '@:resources.user.enums.notificationTypes.outage',
                hint: 'Wichtige Mitteilungen zu aktuellen Störungen und deren Behebung.',
            },
            cancelation: {
                label: '@:resources.user.enums.notificationTypes.cancelation',
                hint: 'Benachrichtigungen rund um Vertragskündigungen oder bevorstehende Laufzeitenden.',
            },
            order_start: {
                label: '@:resources.user.enums.notificationTypes.order_start',
                hint: 'Ankündigungen zum Start von Aufträgen und Vertragsgegenständen.',
            },
            order_approved_by_customer: {
                label: '@:resources.user.enums.notificationTypes.order_approved_by_customer',
                hint: 'Ankündigungen zur Freigabe von Aufträgen.',
            },
            receipt: {
                label: '@:resources.user.enums.notificationTypes.receipt',
                hint: 'Offene Rechnungen und Zahlungen.',
            },
            invoice_paid: {
                label: '@:resources.user.enums.notificationTypes.invoice_paid',
                hint: 'Benachrichtigungen zu bezahlten Rechnungen.',
            },
            attack_started: {
                label: '@:resources.user.enums.notificationTypes.attack_started',
                hint: 'Benachrichtigungen, wenn ein DDoS-Angriff auf Ihre IP-Adressen erkannt wurde.',
            },
            attack_ended: {
                label: '@:resources.user.enums.notificationTypes.attack_ended',
                hint: 'Benachrichtigungen, wenn ein erkannter DDoS-Angriff auf Ihre IP-Adressen beendet wurde.',
            },
            channelPreferences: {
                mail: 'per Mail',
                inbox: 'per Inbox',
            },
            groups: {
                system: 'System & Status',
                orders: 'Aufträge',
                billing: 'Abrechnung',
                protect: '@:pages.AttackIndexPage.title',
                other: 'Weitere',
            },
        },
        apiToken: {
            title: 'API-Zugriff',
            description: 'Verwalten Sie Ihre API-Tokens für den Zugriff auf unsere Schnittstellen.',
            token_name: {
                label: 'Name des Tokens',
                placeholder: 'z.B. Mein Monitoring Skript',
            },
            token: {
                label: 'Ihr neuer Token',
                description:
                    'Kopieren Sie diesen Token jetzt und bewahren Sie ihn sicher und für Dritte unzugänglich auf. Er wird Ihnen aus Sicherheitsgründen nur einmal angezeigt.',
            },
            last_used_at: 'Zuletzt verwendet',
            prefix: 'Präfix',
            noTokens: 'Sie haben noch keine API-Tokens erstellt.',
            create: 'Token erstellen',
            edit: 'Token-Namen bearbeiten',
            delete: 'Token löschen',
            confirmDelete:
                'Möchten Sie diesen Token wirklich löschen? Der Zugriff mit diesem Token wird sofort gesperrt.',
            successCreated: 'Token erfolgreich erstellt.',
            successUpdated: 'Token-Name erfolgreich aktualisiert.',
            successDeleted: 'Token erfolgreich gelöscht.',
        },
        sendFeedback: {
            message: {
                label: 'Ihre Nachricht',
                placeholder: 'Was möchten Sie uns mitteilen?',
            },
            submit: 'Feedback senden',
        },
        ticket: {
            topic: {
                label: '@:resources.ticket.attributes.topic',
                placeholder: 'Wählen Sie ein Thema...',
            },
            subject: {
                label: '@:resources.ticket.attributes.subject',
            },
            description: {
                label: '@:resources.ticket.attributes.description',
            },
            uploads: {
                label: 'Anhänge',
            },
            alerts: {
                info: {
                    question: 'Sie wollen einen Besuch im Datacenter anmelden?',
                    link: 'Nutzen Sie dafür unser neues Anmeldeformular.',
                },
            },
        },
        ticketComment: {
            comment: {
                placeholder: '@:resources.ticketComment.name hinzufügen...',
            },
        },
    },
};
